import { mersPreviewTargetByOperation } from 'constants/loanActionEditor';

import { getMersRowConfig } from '../LoanActionMersRow/LoanActionMersRow.config';

// A preview's kind select and switch are those of the MERS action it previews. A preview only runs manually, so it
// offers the manual kinds.
export const getMersPreviewKindConfig = operation => {
  const target = mersPreviewTargetByOperation[operation];

  return target ? getMersRowConfig(target.actionType, false) : null;
};
